import { observer } from 'mobx-react-lite';
import { useActiveEventPanelTab } from '../../active-event-panel-tab-provider';
import { TabHeaders } from './tab-headers';
import { TabsWrapper } from './tabs-wrapper';
import { ActiveTab } from './active-tab';
import { TabMode } from './types';
import { useEventPanelTabConfigs } from './use-event-panel-tab-configs';

export const EventPanelTabs = observer(function EventPanelTabs({ mode }: { mode: TabMode }) {
    const activeTab = useActiveEventPanelTab();
    const tabConfigs = useEventPanelTabConfigs();
    return (
        <TabsWrapper mode={mode}>
            <>
                <ActiveTab activeTab={activeTab} mode={mode} />
                <TabHeaders activeTab={activeTab} tabConfigs={tabConfigs} />
            </>
        </TabsWrapper>
    );
});
